import React, { useEffect, useState } from 'react';
import { HomeUI } from './ui';
import { Product } from 'src/model/Product';
import { useDispatch } from 'react-redux';
import { setLoading } from 'src/redux/loading/loadingSlice';
import { api } from 'src/services/api';
import { Category } from 'src/model/Category';
import { Banners } from 'src/model/Banners';
import { useHistory } from 'react-router-dom';
import { toCurrency } from 'src/helpers/currency/toCurrency';
import Client from 'src/model/User';

export const HomeScreen: React.FC = (): JSX.Element => {
  const [products, setProdutos] = useState<Product[]>([]);
  const dispatch = useDispatch();
  const [productsLoading, setProductsLoading] = useState<boolean>(true);
  const [categories, setCategories] = useState<Category[]>([]);
  const [banners, setBanners] = useState<Banners[]>([]);
  const [bannerService, setBannerService] = useState<Banners[]>([]);
  const [bannerImages, setBannerImages] = useState<Banners[]>([]);
  const [bannerMidleImages, setBannerMidleImages] = useState<Banners[]>([]);
  const [user, setUser] = useState<Client | undefined>(undefined);
  const history = useHistory();

  const goCategory = (id: string) => {
    history.replace(`/products-by-category/${id}`);
  };
  const goSlide = (id: string) => {
    history.push(`/products-by-category/${id}`);
  };

  const getUser = async (): Promise<void> => {
    try {
      const r = await api.get<Client>('/user/findeone');
      if (r.status === 200) {
        setUser(r.data);
      }
    } catch {
      console.error('Erro ao buscar o usuario');
    }
  };

  const getBannersHome = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Banners[]>(
        '/banner/find-all/PRIMARY_HOME'
      );
      if (response.status === 200) {
        setBanners(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar banners:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getBannersService = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Banners[]>(
        '/banner/find-all/SERVICE_HOME'
      );
      if (response.status === 200) {
        setBannerService(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar banners:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getBannerImages = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Banners[]>(
        '/banner/find-all/SECUDARY_HOME'
      );
      if (response.status === 200) {
        setBannerImages(response.data);
      }
    } catch (erro) {
      console.error('Erro ao buscar banners:', erro);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getBannerMidleImages = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Banners[]>('/banner/find-all/MIDLE_HOME');
      if (response.status === 200) {
        setBannerMidleImages(response.data);
      }
    } catch (erro) {
      console.error('Erro ao buscar banners:', erro);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getCategories = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Category[]>('/category/find-all');
      if (response.status === 200) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar categoria:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const shuffle = <T,>(array: T[]): T[] => {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  const getProduct = async (): Promise<void> => {
    setProductsLoading(true);
    dispatch(setLoading(true));
    try {
      const response = await api.get<Product[]>('/product/all');

      if (response.status === 200) {
        const produtosComEstoque = response.data.filter(
          (produto) => Number(produto.stock) > 0
        );

        setProdutos(shuffle(produtosComEstoque));
      }
    } catch (error) {
      console.error('Erro ao buscar categoria:', error);
    } finally {
      setProductsLoading(false);
      dispatch(setLoading(false));
    }
  };

  const handleValuePrice = (product: Product): string => {
    if (!product.grade) return '';

    for (const grade of product.grade) {
      if (!grade.gradeSizes) continue;

      for (const gradeSize of grade.gradeSizes) {
        if (!gradeSize.price) continue;

        const { price, discount } = gradeSize.price;
        const applyDiscount = product.promotion && discount > 0;

        const finalPrice = applyDiscount
          ? price - (price * discount) / 100
          : price;

        return toCurrency(finalPrice);
      }
    }

    return '';
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getProduct();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getCategories();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBannersHome();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBannersService();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBannerImages();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBannerMidleImages();
    // eslint-disable-next-line
  }, []);

  return (
    <HomeUI
      goCategory={goCategory}
      goSlide={goSlide}
      bannerImages={bannerImages}
      bannerMidleImages={bannerMidleImages}
      product={products}
      productsLoading={productsLoading}
      categories={categories}
      banners={banners}
      bannerService={bannerService}
      valuePrice={handleValuePrice}
      user={user}
    />
  );
};
